import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import File from '#images/library/file.svg'

@inject('packsStore')
@observer
class Cover extends Component {
  render() {
    const { item } = this.props
    return (
      <div
        className='relative flex cursor-pointer min-w-[60px] max-w-[60px] min-h-[60px] max-h-[60px]'
        onClick={this.props.onClick}
      >
        {
          item.product_id && (
            <img
              src={this.props.cover || this.props.packsStore.getCover(this.props.productId)}
              className='object-cover w-full hover:absolute hover:w-[62px] hover:h-[62px] hover:max-w-none hover:-translate-y-1/2 hover:top-1/2'
            />

          )
        }

        {
          !item.product_id && item.owned && (
            <img src={File} className='object-cover' />
          )
        }

        {
          !item.product_id && !item.owned && (
            <img className='object-cover' />
          )
        }
      </div>
    )
  }
}

export default Cover